import PublicationRecord from "models/view-models/publication-record";
import NumberUtils from "utilities/number-utils";
import FileService from "utilities/services/file-service";

const usePublicationCover = (publication: PublicationRecord) => {
    const { get: getFileApi } = FileService.useGetQuery();

    const getFileResult = getFileApi(
        { id: publication.coverImageFileId! },
        undefined,
        {
            enabled:
                !publication.coverImageFile &&
                !NumberUtils.isDefault(publication.coverImageFileId),
        }
    );

    const imageFile = getFileResult?.data?.resultObject;

    const coverImageSrc =
        imageFile?.presignedUrl ?? publication.coverImageFile?.presignedUrl;

    return { coverImageSrc };
};

export default usePublicationCover;
